import { ModelProps } from "./Model";
import { useControls } from "leva";
import { useLabel } from "@/hooks/useLabel";
import { memo } from "react";
import { useFilterIsShaken } from "@/hooks/useFilter";

// Make a suspense that waits for the correct texture to be ready
export const Label = memo(function Label({ nodes, textures }: ModelProps) {
  const [isShaken] = useFilterIsShaken()
  const { texture, imageData } = useLabel();
  const [controls] = useControls(
    "Label",
    () => ({
      scale: { value: 1.01, min: 0, max: 5, step: 0.01 },
      polygonOffsetFactor: { value: 0, min: -100, max: 100, step: 0.01 },
      roughness: { value: 0, min: 0, max: 1, step: 0.01 },
      normal: { value: 1, min: 0, max: 100, step: 0.01 },
    }),
    { collapsed: true },
    []
  );

  return (
    <mesh
      visible={isShaken}
      name="Label"
      castShadow={false}
      receiveShadow={false}
      geometry={nodes.Label.geometry}
      scale={controls.scale}
    >
    <meshStandardMaterial
      map={texture}
      polygonOffset
      polygonOffsetFactor={controls.polygonOffsetFactor}
      normalMap={textures?.normals ?? null}
      roughnessMap={textures?.rough ?? null}
      normalScale={[controls.normal, controls.normal] as [number, number]}
      roughness={controls.roughness}
    />

    </mesh>
  );
}); 
